import React, { useRef, useState, useEffect } from "react"
import PropTypes from "prop-types"
import Map, { Marker, NavigationControl, Popup } from "react-map-gl";
import mapboxgl from "mapbox-gl";

const SimpleMap = (params) => {
  mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

  const mapRef = useRef();
  const [mapLocations, setMapLocations] = useState(null);
  const [mapJobs, setMapJobs] = useState(null);
  const [mapViewState, setMapViewState] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);

  useEffect(() => {
    if (!params.locations) return;
    setMapLocations(params.locations);
  }, [params.locations]);

  useEffect(() => {
    if (!params.jobs) return;
    setMapJobs(params.jobs);
  }, [params.jobs]);

  function fitToLocations() {
    if (!mapRef.current) return;

    const bounds = new mapboxgl.LngLatBounds();
    if (mapLocations) {
      mapLocations.forEach((loc) => bounds.extend([loc.longitude, loc.latitude]));
    }
    if (mapJobs) {
      mapJobs.forEach((job) => bounds.extend([job.longitude, job.latitude]));
    }
    if (bounds.isEmpty()) return;

    mapRef.current.fitBounds(bounds, { padding: 100, maxZoom: 15, animate: false });
  }

  function renderMarkers() {
    const markers = mapLocations.map((location, index) => {
      return <Marker key={index} longitude={location.longitude} latitude={location.latitude} anchor="bottom" onClick={(e) => { e.originalEvent.stopPropagation(); setSelectedLocation(location); }} />;
    });
    return (
      <>{markers}</>
    );
  }

  function renderJobMarkers() {
    if (!mapJobs) return null;
    const markers = mapJobs.map((job, index) => {
      return (
        <Marker key={`job-${index}`} longitude={job.longitude} latitude={job.latitude} anchor="center" onClick={(e) => { e.originalEvent.stopPropagation(); setSelectedJob(job); }}>
          <div style={{ width: 20, height: 20, backgroundColor: job.color, borderRadius: "50%", border: "1px solid black" }} />
        </Marker>
      );
    });
    return <>{markers}</>;
  }

  return (
    <div>
      <div className="map-container">
        {(mapLocations || mapJobs) && <Map
          ref={mapRef}
          {...mapViewState}
          scrollZoom={false}
          onMove={evt => setMapViewState(evt.viewState)}
          onLoad={fitToLocations}
          mapStyle="mapbox://styles/mapbox/streets-v9"
          mapboxAccessToken="pk.eyJ1IjoiZGV2c3BhY2VvbmUiLCJhIjoiY2tyMXI0N3U4MjRsbTJ2cWFlOWR1OGM0NCJ9.hBD-m-8DIlw9dMKYpAs-zQ"
        >
          <NavigationControl />
          {mapLocations && renderMarkers()}
          {renderJobMarkers()}
          {selectedLocation && (
            <Popup
              longitude={selectedLocation.longitude}
              latitude={selectedLocation.latitude}
              anchor="bottom"
              offset={40}
              onClose={() => setSelectedLocation(null)}
            >
              <div>{selectedLocation.name}</div>
            </Popup>
          )}
          {selectedJob && (
            <Popup
              longitude={selectedJob.longitude}
              latitude={selectedJob.latitude}
              anchor="bottom"
              offset={10}
              onClose={() => setSelectedJob(null)}
            >
              <div>{selectedJob.name}</div>
            </Popup>
          )}
        </Map>}
      </div>
    </div>
  );
};

SimpleMap.propTypes = {
  locations: PropTypes.array,
  jobs: PropTypes.array
};

export default SimpleMap;
